<template>
  <b-table
    :items="perfis"
    :fields="fields"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    stacked="md"
    responsive
    show-empty
    striped
    hover
    @sort-changed="aoMudarOrdenacao"
  >
       <template #cell(acoes)="item">
        <b-dropdown variant="outline-default" v-if="mostrarAcoes" :disabled="!item.item.permiteModificacao">
          <b-dropdown-item
            @click="irPara('perfil-permissao', item.item.id)"
            v-if="podeEditar"
          >
            {{ $t('GERAL.GERENCIAR_PERMISSOES') }}
          </b-dropdown-item>
          <b-dropdown-item
            @click="editar(item.item)"
            v-if="podeEditar"
          >
            {{ $t('GERAL.EDITAR') }}
          </b-dropdown-item>
          <b-dropdown-item @click="excluir(item.item)" v-if="podeExcluir">
            {{ $t('GERAL.EXCLUIR') }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
  </b-table>
</template>
<script>
import helpers from '@/common/utils/helpers';
import Permisoes from '@/components/mixins/permissoes';
export default {
  props: {
    perfis: { type: Array, default: Array },
  },
  mixins: [Permisoes],
  data() {
    return {
      fields: [
        {
          key: 'nome',
          label: this.$t('USUARIOS.NOME'),
          sortable: true,
        },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
          class: 'text-center',
          thClass: 'coluna-acoes',
          tdClass: 'coluna-acoes',
        },
      ],
      badgesPerfil: {
        admin: 'danger',
        responsavel: 'success',
        aluno: 'info',
      },
    };
  },
  computed: {
    mostrarAcoes() {
      return this.podeEditar || this.podeExcluir;
    },
  },
  methods: {
    irPara(path, idPerfil){
      this.$emit('irPara', ('perfil-permissao', { path, idPerfil}));
    },
    editar(item) {
      this.$emit('editar', 'perfil', item);
    },
    excluir(item) {
      this.$emit('excluir', item);
    },
     aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>

<style>
  table td, table th, .table td {
    height: 45px;
  }
  .coluna-acoes {
    width: 150px;
  }

  .text-center {
    text-align: center;
  }
</style>